import { Table } from 'antd';
import React, { useEffect, useState } from 'react';
import tinycolor from 'tinycolor2';
import { CustomTableItem, CustomTableProps } from './custom-table.config';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const CustomTable: React.FC<CustomTableProps> = (props) => {
  const { t } = useTranslation();

  const [pagination, setPagination] = useState<any>({
    current: props.currentPage || 1,
    pageSize: props.pageSize || 20,
    pageSizeOptions: [10, 20, 30, 50, 100],
    showSizeChanger: true,
    onChange: (_: any, pageSize: any) => {
      setPagination((prev: any) => ({
        ...prev,
        pageSize,
      }));
    },
  });

  const [filteredData, setFilteredData] = useState<any[]>([]);

  useEffect(() => {
    if (props.showTodayBasedOn) {
      const todayDate = props.currentUnixTime ? new Date(props.currentUnixTime) : new Date();

      const allKeys = new Set<string>();
      props.dataSource.forEach((item: any) => {
        Object.keys(item).forEach((key) => allKeys.add(key));
      });

      const beforeToday = props.dataSource.filter((item: any) =>
        props.showTodayBasedOn && item[props.showTodayBasedOn] ? item[props.showTodayBasedOn] < todayDate : false,
      );

      const afterToday = props.dataSource.filter((item: any) =>
        props.showTodayBasedOn && item[props.showTodayBasedOn] ? item[props.showTodayBasedOn] > todayDate : false,
      );

      const todayRow: CustomTableItem = {
        [props.showTodayBasedOn]: todayDate,
        rowColor: 'repeating-linear-gradient(50deg, white, white 10px, red 10px, red 20px)',
        rowPadding: '4px 16px',
      };

      allKeys.forEach((key) => {
        if (key === props.showTodayBasedOn || key === 'rowColor') return;

        const firstValue = _.find(props.dataSource, (item) => !_.isUndefined(item[key]))?.[key];

        if (_.isArray(firstValue)) {
          if (_.some(firstValue, _.isObject)) {
            todayRow[key] = [_.mapValues(_.first(firstValue), () => '')];
          } else {
            todayRow[key] = [''];
          }
        } else {
          todayRow[key] = '';
        }
      });

      setFilteredData([...beforeToday, todayRow, ...afterToday]);
    }
  }, [props.dataSource, props.showTodayBasedOn]);

  useEffect(() => {
    setPagination((prev: any) => ({
      ...prev,
      current: props.currentPage || prev.current,
      pageSize: prev.pageSize ? prev.pageSize : 10,
      total: props.numberOfTotalPage || props.dataSource.length,
      showTotal: () => {
        if (props.id === 'mainIncidentTable') {
          return `${t('general.total')} ${props.dataSource.length - 1} ${t('general.items')}`;
        } else if (props.id === 'eventLogs') {
          return `${t('general.total')} ${props.numberOfTotalPage} ${t('general.items')}`;
        } else if (props.id === 'lillDataTable') {
          return `${t('general.total')} ${props.dataSource.length - 1} ${t('general.items')}`;
        } else {
          return `${t('general.total')} ${props.dataSource.length} ${t('general.items')}`;
        }
      },
    }));
  }, [props.currentPage, props.pageSize, props.numberOfTotalPage, props.dataSource]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          flex: 1,
        }}
      >
        <Table
          id={props.id ? props.id : undefined}
          rowKey="id"
          scroll={props.scroll ? props.scroll : { x: '100vw', y: 'calc(100vh - 350px)' }}
          bordered
          className={props.className ? props.className : undefined}
          loading={props.loading}
          dataSource={props.showTodayBasedOn ? filteredData : props.dataSource}
          columns={props.columns}
          rowClassName={props.rowClassName ? props.rowClassName : undefined}
          pagination={
            props.id === 'emailSettingsTable'
              ? false
              : props.id === 'mainIncidentTable' || props.id === 'eventLogs' || props.id === 'lillDataTable'
              ? {
                  ...pagination,
                  showTotal: () => {
                    if (props.id === 'mainIncidentTable') {
                      return `${t('general.total')} ${filteredData.length - 1}  ${t('general.items')}`;
                    } else if (props.id === 'lillDataTable') {
                      return `${t('general.total')} ${props.dataSource.length - 1}  ${t('general.items')}`;
                    } else if (props.id === 'eventLogs') {
                      return `${t('general.total')} ${props.numberOfTotalPage}  ${t('general.items')}`;
                    } else {
                      return `${t('general.total')} ${filteredData.length}  ${t('general.items')}`;
                    }
                  },
                  onChange: (page, pageSize) => {
                    if (props.onPageChange) {
                      props.onPageChange(page, pageSize);
                    }
                    setPagination((prev: any) => ({
                      ...prev,
                      current: page,
                      pageSize,
                    }));
                  },
                }
              : {
                  ...pagination,
                  onChange: (page, pageSize) => {
                    if (props.onPageChange) {
                      props.onPageChange(page, pageSize);
                    }
                    setPagination((prev: any) => ({
                      ...prev,
                      current: page,
                      pageSize,
                    }));
                  },
                }
          }
          onChange={(pagination, filters, sorter, extra) => {
            if (props.onChange) {
              props.onChange(filters, sorter, pagination, extra);
            }

            setPagination((prev: any) => ({
              ...prev,
              total: extra.currentDataSource.length,
              showTotal: () => ` ${t('general.total')} ${extra.currentDataSource.length}  ${t('general.items')}`,
            }));
          }}
          onRow={(record, index) => {
            const additionalProps = props.onRow ? props.onRow(record, index) : {};
            return {
              style: {
                '--row-padding': record.rowPadding ? record.rowPadding : '16px 16px',
                '--row-color': record?.rowColor,
                color: tinycolor(record.rowColor).isDark() ? '#fff' : '#000',
                height: record.height ? record.height : 'auto',
              },
              ...additionalProps,
            };
          }}
        />
      </div>
    </div>
  );
};

export default CustomTable;
